export default __webpack_public_path__ + "static/media/4.37f0ec4a.jpg";